/**
 * @module JQM
 */
(function ($) {

    'use strict';

    if (typeof JQM === 'undefined') {
        return null;
    }

    /**
     * CloseStatusMessage module
     *
     * @class JQM.CloseStatusMessage
     */
    var CloseStatusMessage = (function() {

        /**
         * Reference on the container
         *
         * @private
         * @property container
         * @type {Object}
         */
        var container,

        /**
         * Reference on the close button 
         *
         * @private
         * @property closeBtn
         * @type {Object}
         */
            closeBtn;


        /**
         * Initialization of the drupal-messages container
         *
         * @method init
         */
        function init() {
            container = $('.drupal-messages');

            if (container.length) {
                closeBtn = container.find('.drupal-messages--close-btn');

                initListener();
            }
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {
            closeBtn.click(function(){
                $(this).closest(container).fadeOut();
            });
        }

        /**
         * @return Public-API
         */
        return {
            init : init
        };

    }());

    /**
     *
     * @for JQM
     * @property CloseStatusMessage
     * @type {Function}
     */
    JQM.CloseStatusMessage = CloseStatusMessage;

    return CloseStatusMessage;

}(jQuery));
